import { Pipe, PipeTransform } from '@angular/core';
import { ListingModelesText, ListingModelesVideo } from '@components/listing-modeles/models';

@Pipe({ name: 'isListingModelesText', standalone: true })
export class IsListingModelesTextPipe implements PipeTransform {
  transform(value: ListingModelesText | ListingModelesVideo): value is ListingModelesText {
    return 'text' in value;
  }
}
